import React, { useContext, useEffect, useState } from "react";
import { Box, Text, Flex, Heading } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { UserCard } from "./components/UserCard";
import { UserMeter } from "./components/UserMeter";
import { AlertSection } from "./components/AlertSection";
import { UserProfileContext } from "../../context/UserContext";
// import { getUserProfile } from "../../context/getUser";
import FullPageLoader from "../../components/fullPageLoader";

export const Profile = () => {
  const { userProfile } = useContext(UserProfileContext) || {};
  const [refresh, setRefresh] = useState(false);
  const [loading] = useState(false);
  //  const [usersProfile] = useState({})
  const userId = useSelector((state) => state?.auth?.userId);
  useEffect(() => {
    // getUserProfile(userId, setUsersProfile, setLoading);
    // getUserInfomation(setLoading, _id, setUserInformation);
  }, [refresh, userId]);

  // console.log("usersProfile", usersProfile);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Box p={["10px", "10px", "0px"]}>
      <Box
        color="primary.500"
        fontSize={"27px"}
        fontWeight="bold"
        py={"20px"}
        pl={["5px", "5px", "0"]}
      >
        <Heading>User Profile</Heading>
      </Box>
      <Flex direction={["column", "column", "row"]}>
        <Box
          w={["100%", "100%", "53%"]}
          mr={["0", "0", "40px"]}
          mb={["16px", "16px", "0"]}
        >
          <UserCard userProfile={userProfile} setRefresh={setRefresh} />
        </Box>
        <Box w={["100%", "100%", "42%"]}>
          <UserMeter setRefresh={setRefresh} userProfile={userProfile} />
        </Box>
      </Flex>
      {/* <Text fontWeight="bold" my="20px">
         Alerts
       </Text> */}
      <Box>{/* <AlertSection /> */}</Box>
    </Box>
  );
};
